import React from 'react';
import { Button } from '../buttons/button';
import { ICONS } from '../../constants/imageConstants';

const UserProfile = ({ user, className = '', showLogoutButton = false, onLogout, onImageClick }) => {
  const userInfo = user || {};
  const profileImage = userInfo.profile_image_local || userInfo.profile_image || ICONS.USER_AVATAR;

  return (
    <div className={`flex gap-4 items-center justify-between ${className}`}>
      <div className="flex gap-4 items-center">
        <button onClick={() => onImageClick && onImageClick(profileImage)} className="w-12 h-12 rounded-full bg-neutral-200 flex items-center justify-center overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          <img 
            src={profileImage}
            alt="User Avatar" 
            className="w-full h-full object-cover"
            onError={(e) => { e.target.onerror = null; e.target.src = ICONS.USER_AVATAR; }}
          />
        </button>
        <div>
          <span className="block text-lg font-semibold text-neutral-900">{userInfo.full_name || 'User'}</span>
          <span className="block text-sm text-neutral-600 tracking-tight">{userInfo.email || 'No email'}</span>
        </div>
      </div>

      {showLogoutButton && onLogout && (
        <Button onClick={onLogout} variant="secondary" className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-600">
          <img src={ICONS.LOGOUT_MODAL} alt="Logout" className="mr-2" />
          Logout
        </Button>
      )}
    </div>
  );
};

export default UserProfile;